








































import { mapGetters, mapActions } from 'vuex'
import MainNavbar from '@/components/MainNavbar.vue'

export default {
  name: 'CustomerDashboard',
  components: {
    MainNavbar
  },
  data () {
    return {
      selections: []
    }
  },
  computed: {
    ...mapGetters([
      'currentCustomer',
      'riskLevels',
      'assessmentHistory',
      'currentQuarter',
      'currentYear',
      'lastYear'
    ]),
    customerHasCurrentSubmission () {
      if (this.assessmentHistory && Array.isArray(this.assessmentHistory)) {
        for (let s=0, l=this.assessmentHistory.length; s<l; s++) {
          if (this.assessmentHistory[s].period == this.currentYear) return true
        }
      }
      return false
    }
  },
  methods: {
    ...mapActions([
      'getAssessmentHistory'
    ]),
    review (subId: number) {
      this.$router.push('/risk-assessment/review/'+subId)
    }
  },
  async mounted () {
    console.log('CustomerDashboard.mounted')
    this.getAssessmentHistory()
  },
  watch: {
  }
}
